import React from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router';
import logo from './assets/img/logo.png'

const NerverDie5566 = (props) => {
    return (
        <Wrapper>
            <Container>
                <Content>
                <img src={logo} alt=''/>
                </Content>
            </Container>
        </Wrapper>
    )
}
export default withRouter(NerverDie5566);
const Wrapper = styled.div`
    min-height: 100vh;    
    overflow: scroll;
    background-color: #fafafa;
    border-left: 1px solid #e6e6e6;
`
const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center; 
    width: 100%;
    height: auto;
    padding: 50px 0;
`
const Content = styled.div`
    display: flex;
    justify-content: center;
    min-width: 900px;
    padding: 36px;
    margin-bottom: 32px;
    background-color: #fff;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);         
    color: #787878;
    @media (max-width: 900px){
        min-width: 320px;
        margin: 0 10px;
    } 
`



// WEBPACK FOOTER //
// ./src/5566.js